import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import authStore from '../stores/authStore'
import { routes } from '../utils/constants'


const useRenderOnNotAuthenticated = () => {
  const navigate = useNavigate()

  useEffect(() => {
    if (authStore.userIsLoggedIn) navigate(routes.DASHBOARD)
  }, [navigate])

  return !authStore.userIsLoggedIn
}

export default useRenderOnNotAuthenticated

